const isB2BPath = (url) => url?.includes('/b2b') || false

export default isB2BPath
